import React from 'react';


export const StageEducation = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Which party's residence will determine the school district?</label>
              <div className="grid grid-cols-3 gap-2">
                {[
                  { id: 'plaintiff', label: 'Plaintiff' },
                  { id: 'defendant', label: 'Defendant' },
                  { id: 'joint', label: 'Joint Decision' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('schoolDistrictResidence', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.schoolDistrictResidence === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'school-district-' + opt.id}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">School Selection / Enrollment Decisions</label>
              <select value={planData.schoolChoice} onChange={function(e) { updateData('schoolChoice', e.target.value); }}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2" data-testid="school-choice">
                <option value="">Select arrangement</option>
                <option value="joint">Joint Decision</option>
                <option value="plaintiff">Plaintiff Decides</option>
                <option value="defendant">Defendant Decides</option>
                <option value="current-district">Continue Current District Enrollment</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">School Type</label>
              <select value={planData.schoolType} onChange={function(e) { updateData('schoolType', e.target.value); }}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                <option value="">Select school type preference</option>
                <option value="public">Public School</option>
                <option value="private">Private School</option>
                <option value="charter">Charter School</option>
                <option value="homeschool">Homeschool</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Major Academic Decisions — Authority</label>
              <p className="text-xs text-white/40 mb-2">Who has authority over major educational decisions?</p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'joint', label: 'Joint Decision' },
                  { id: 'plaintiff', label: 'Plaintiff Decides' },
                  { id: 'defendant', label: 'Defendant Decides' },
                  { id: 'primary-custodian', label: 'Primary Custodial Parent' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('academicAuthority', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.academicAuthority === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">504 Plans / IEP (Individualized Education Program)</label>
              <p className="text-xs text-white/40 mb-2">How will decisions about special education services, 504 accommodations, or IEP plans be handled?</p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'joint-participation', label: 'Both Parents Participate in Meetings & Decisions' },
                  { id: 'plaintiff-lead', label: 'Plaintiff Leads IEP/504' },
                  { id: 'defendant-lead', label: 'Defendant Leads IEP/504' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('iep504Plan', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.iep504Plan === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Tie-Breaker Authority Over Academic Decisions</label>
              <p className="text-xs text-white/40 mb-2">If parents cannot agree on an academic decision, who has final say?</p>
              <div className="grid grid-cols-3 gap-2">
                {[
                  { id: 'plaintiff', label: 'Plaintiff' },
                  { id: 'defendant', label: 'Defendant' },
                  { id: 'mediator', label: 'Mediator Decides' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('academicTiebreaker', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.academicTiebreaker === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'tiebreaker-' + opt.id}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Extracurricular Activities</label>
              <div className="space-y-2">
                {[
                  { id: 'joint-approval', name: 'Joint Approval Required', desc: 'Both parents must agree on new activities' },
                  { id: 'each-during', name: 'Each Parent During Their Time', desc: 'Each parent enrolls activities during their parenting time' },
                  { id: 'discuss-then-enroll', name: 'Discuss First, Either May Enroll', desc: 'Discuss activities but either parent may enroll' },
                  { id: 'cost-cap', name: 'Joint w/ Cost Cap', desc: 'Joint approval required; agree on a per-activity cost limit' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('extracurriculars', opt.id); }}
                      className={planData.extracurriculars === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#5A4E9E] bg-[#5A4E9E]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Non-School Activities (sports, music lessons, dance, gymnastics, cheer)</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'joint-approval', label: 'Both Parents Must Approve' },
                  { id: 'either-parent', label: 'Either Parent May Enroll' },
                  { id: 'custodial-decides', label: 'Custodial Parent Decides' },
                  { id: 'cost-threshold', label: 'Joint If Over Cost Threshold' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('afterSchoolClubs', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.afterSchoolClubs === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            {(planData.extracurriculars === 'cost-cap' || planData.afterSchoolClubs === 'cost-threshold') && (
              <div className="p-4 bg-[#EAB308]/5 border border-[#EAB308]/20 rounded-xl space-y-3" data-testid="activity-cost-cap-section">
                <label className="block text-sm font-medium">Per-Activity Cost Cap</label>
                <p className="text-xs text-white/40">Set the maximum cost per activity before requiring joint approval.</p>
                <div className="flex items-center gap-2">
                  <span className="text-white/50">$</span>
                  <input type="number" min="0" step="25"
                    value={planData.activityCostCap || ''}
                    onChange={function(e) { updateData('activityCostCap', e.target.value); }}
                    placeholder="e.g. 250"
                    className="w-40 bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2 text-sm focus:outline-none focus:border-[#EAB308]/40"
                    data-testid="activity-cost-cap-input" />
                  <span className="text-xs text-white/40">per activity / per season</span>
                </div>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium mb-2">Religious/Spiritual Upbringing</label>
              <select value={planData.religiousUpbringing} onChange={function(e) { updateData('religiousUpbringing', e.target.value); }}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                <option value="">Select arrangement</option>
                <option value="joint">Joint Decision</option>
                <option value="plaintiff">Plaintiff Decides</option>
                <option value="defendant">Defendant Decides</option>
                <option value="exposure-both">Expose to Both Traditions</option>
                <option value="none">No Religious Instruction</option>
              </select>
            </div>
          </div>
        
  );
};
